import { fetchAPI, METHODS, parseBody } from './common';

export async function getSystemConfig() {
  const res = await fetchAPI('/config', METHODS.get, null, {
    noAuthRefresh: true,
  });
  return parseBody(res);
}
